import { Badge, Box, Typography } from "@mui/material";
import { assetsApi } from "@platformx/authoring-apis";
import { ArrowDownBlack, FolderBlackLarge, FolderBlue } from "@platformx/shared/static-assets";
import { AUTH_INFO, capitalizeFirstLetter, isSubsequence } from "@platformx/utilities";
import { Dispatch, FC, SetStateAction } from "react";
import { SUBCOMMUNITIES } from "../../utils/constants";

import useDamContent from "./DamContent.style";

interface Community {
  uuid: string;
  name: string;
  type: string;
  handle: string;
  subcommunities: {
    subcommunities: Community[];
    page: {
      number: number;
      size: number;
      totalPages: number;
      totalElements: number;
    };
  };
}

interface CommunityMenuProps {
  communities: Community[];
  setUuid: Dispatch<SetStateAction<string | undefined>>;
  assetType: string;
  uuid: string;
  searchQuery: string;
  setCategoryLoading?: any;
  folder?: any;
  setFolder?: any;
  prevFolderState?: any;
  setPrevFolderState?: any;
  totalImageItem?: any;
  isImgLoad?: any;
}

const FolderMenu: FC<CommunityMenuProps> = ({
  communities,
  setUuid,
  assetType,
  uuid,
  searchQuery,
  setCategoryLoading,
  folder,
  setFolder,
  prevFolderState,
  setPrevFolderState,
  totalImageItem,
  isImgLoad,
}) => {
  const classes = useDamContent();
  // const [folder, setFolder] = useState<any>({});
  const { fetchDAMContent } = assetsApi;
  function filterFolder(arr) {
    return searchQuery
      ? arr?.filter((obj) => isSubsequence(searchQuery, obj.name.toLowerCase()))
      : arr;
  }

  const list = folder?.name
    ? filterFolder(folder?.subcommunities?.subcommunities || [])
    : filterFolder(communities);

  const getDamChildMenucontent = async (obj, searchTerm = "") => {
    setCategoryLoading(true);

    try {
      const { authoring_getAssets = {} } = await fetchDAMContent({
        uuid: obj.uuid,
        start: 0,
        rows: 16,
        search: searchTerm,
        entityType: "ALL",
        assetType: SUBCOMMUNITIES,
        tags: {},
        sortBy: "DESC",
        playbackStatus: "ALL",
      });

      const newFolder = {
        ...obj,
        subcommunities: {
          subcommunities: authoring_getAssets.subcommunitiesList || [],
        },
      };

      setFolder(newFolder);
    } catch (error) {
      console.error("Failed to fetch content:", error);
    } finally {
      setCategoryLoading(false);
    }
  };

  const handleClick = (obj) => {
    setPrevFolderState((prev) => [...prev, folder]);

    if (obj?.subcommunities?.subcommunities?.length > 0) {
      setFolder(obj);
    } else {
      getDamChildMenucontent(obj, "");
    }
    setUuid(obj.uuid);
  };
  const handleReset = () => {
    // setFolder({});
    if (prevFolderState.length > 0) {
      const prev = prevFolderState[prevFolderState.length - 1];
      setFolder(prev);
      // eslint-disable-next-line no-shadow
      setPrevFolderState((prev: any) => prev.slice(0, prev.length - 1)); // pop from history
      setUuid(
        prev?.uuid
          ? prev.uuid
          : assetType === "Image"
            ? AUTH_INFO.dspaceImagesUuid
            : AUTH_INFO.dspaceVideosUuid,
      );
    }
    // setUuid(assetType === "Image" ? AUTH_INFO.dspaceImagesUuid : AUTH_INFO.dspaceVideosUuid);
  };
  const getShortTitle = (val) => {
    if (val.length > 18) {
      return `${capitalizeFirstLetter(val.slice(0, 17))}...`;
    } else {
      return capitalizeFirstLetter(val);
    }
  };
  return (
    <>
      {folder?.name && (
        <Box className={`${classes.folderBox} nextlevel`}>
          <Box onClick={handleReset} sx={{ display: "flex" }}>
            <img style={{ transform: "rotate(90deg)" }} src={ArrowDownBlack} alt='back' />
            <Typography variant='p2medium' data-uuid={`${uuid}`} className={classes.folderLabel}>
              {getShortTitle(folder.name)}
              {!isImgLoad && (
                <Badge
                  classes={{ badge: classes.customBadge }}
                  showZero
                  sx={{
                    margin: "0 0 0 1rem",
                  }}
                  badgeContent={totalImageItem}></Badge>
              )}
            </Typography>
          </Box>
        </Box>
      )}
      {list?.map((obj, i) => {
        return (
          <Box
            key={i}
            className={`${classes.folderBox} ${folder?.name ? "firstLevel" : ""}`}
            onClick={() => (obj.uuid === uuid ? handleReset() : handleClick(obj))}
            data-testid='rest-folder-menu'>
            <Box sx={{ display: "flex" }}>
              <img src={obj.uuid === uuid ? FolderBlue : FolderBlackLarge} alt='folder' />
              <Typography
                variant='p3medium'
                data-uuid={`${uuid}`}
                color={obj.uuid === uuid ? "activeColor" : "inherit"}
                className={classes.folderLabel}>
                {getShortTitle(obj.name)}
              </Typography>
            </Box>
            <img
              style={{ transform: "rotate(270deg)", marginRight: "5px" }}
              src={ArrowDownBlack}
              alt='icon'
            />
          </Box>
        );
      })}
    </>
  );
};

export default FolderMenu;
